(function() {
	'use strict';

	function WakeHistoryController($scope, $window) {
		$scope.wakeHistory = $window.wakeHistory;
		
		var item = {};
		try {
			item = window.localStorage.getItem('__wake_hist');
		} catch (e) {
			return {};
		}

		$scope.city = $scope.wakeHistory.getHistory('seller-county') || null;

		$scope.storage = JSON.parse(item || '{}');

		$scope.show = function (value) {
			return ($scope.wakeHistory.getHistory(value) !== undefined && !$scope.inQuarantine());
		};
		$scope.showCurrent = function (level) {
			return ($scope.wakeHistory.getCurrentHistory(level) !== undefined);
		};

		$scope.inQuarantine = function () {
			var today = new Date().getTime();
			var path = $window.location.pathname.split('/')[1];
			var inQuarantine = false;

			if ($scope.storage["quarantine"] && $scope.storage["quarantine"].length > 0) {
				angular.forEach($scope.storage["quarantine"], function(item) {
					if (item.path && item.path == path) {
						var until = item.quarantineUntil ? new Date(item.quarantineUntil * 1000).getTime() : null;
						if (until > today) {
							inQuarantine = true;
							return;
						} else {
							/* Remove expired quarantine item */
							$scope.storage["quarantine"].splice($scope.storage["quarantine"].indexOf(item), 1);
							window.wakeHistory.trackHistory("quarantine", $scope.storage["quarantine"]);
							inQuarantine = false;
						}
					}
				});
			}

			return inQuarantine;
		};

		$scope.setQuarantine = function (county) {
			var path = $window.location.pathname.split('/')[1];
			var date = new Date();
			date.setDate(date.getDate() + 7);

			var quarantineItem = {
				path: path,
				quarantineUntil: Date.parse(date) / 1000
			};

			if ($scope.storage["quarantine"] && $scope.storage["quarantine"].length) {
				$scope.storage["quarantine"].push(quarantineItem);
			} else {
				$scope.storage["quarantine"] = [];
				$scope.storage["quarantine"].push(quarantineItem);
			}

			window.wakeHistory.trackHistory("quarantine", $scope.storage["quarantine"]);
		};
	}

	WakeHistoryController.$inject = ['$scope', '$window'];

	angular.module('KimaMain').controller("WakeHistoryController", WakeHistoryController);

})();